import { useTranslations } from "next-intl";

import type {
  TCatLifestyleCardCat,
  TUseCatLifestyleCard,
} from "./CatLifestyleCard.config";
import { useCatBodyType, useCatLifestyle, useCatWeight } from "@/hooks";

export const useCatLifestyleCard = (
  cat: TCatLifestyleCardCat,
): TUseCatLifestyleCard => {
  const t = useTranslations("Libs.UI.Components.CatLifestyleCard");
  const tActions = useTranslations("Shared.Actions");

  const catBodyType = useCatBodyType().translate(cat.bodyType);
  const catLifeStyle = useCatLifestyle().translate(cat.lifestyle);
  const catWeight = useCatWeight(cat.weight);

  return {
    healthStats: [
      { icon: "playingCat", label: t("weight"), value: catWeight },
      { icon: "standingCat", label: t("bodyType"), value: catBodyType },
      { icon: "sleepingCat", label: t("lifestyle"), value: catLifeStyle },
    ],
    healthTitle: t("health"),
    portionSizeTitle: t("portionSize", { name: cat.name }),
    dailyCalories: t("dailyCalories", { calories: cat.calories }),
    editCopy: tActions("edit"),
    editHealthAriaLabel: t("editHealth"),
    editCaloriesAriaLabel: t("editCalories"),
    caloriesDescription: (cat.suggestedCalories && cat.calories) ? t("caloriesDescription", {
      name: cat.name,
      suggestedCalories: cat.suggestedCalories,
      isRecommended: cat.calories === cat.suggestedCalories,
    }) : null,
  };
};
